module.exports = __webpack_public_path__ + "static/media/tooltip.6c602d7c.svg";